export default __webpack_public_path__ + "static/media/btn-close.f041ea9b.svg";